import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {AccreditationBody, AttachedQuestion, EstimateQuestion, StandardName} from "../../../../store/state/order.state";
import {ChangeSet} from "../../history/order-history.model";
import {TranslationsHelperService} from "../../../translations/translations-helper.service";

@Component({
    selector: 'long-option-single-choice-details',
    templateUrl: './long-option-single-choice-details.template.html',
    styleUrls: ['./long-option-single-choice-details.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LongOptionSingleChoiceDetailsComponent {

	@Input() standard: StandardName;
	@Input() question: EstimateQuestion;
	@Input() changeSet: ChangeSet;
	@Input() translateClientsData: boolean;
	@Input() useOriginalTranslations: boolean;
	@Input() accreditationBody: AccreditationBody;

	constructor(public translationsHelper: TranslationsHelperService) {
	}

	hasAnswerChanged(): boolean {
		return !!this.changeSet && !!this.changeSet.changes.productChanges[this.standard] &&
			!!this.changeSet.changes.productChanges[this.standard].estimateQuestions &&
			!!this.changeSet.changes.productChanges[this.standard].estimateQuestions[this.question.questionId];
	}

	uniqueName() {
		// added milliseconds to distinguish radio buttons in different components: UMB-5539
		return "radio-button" + new Date().getMilliseconds();
	}

	getTranslationSubjectFor(question: EstimateQuestion, attachedQuestion: AttachedQuestion): string {
		return `estimateQuestion[${question.questionId}][${attachedQuestion.type}]`;
	}
}
